import { render, staticRenderFns } from "./Tarrifs.vue?vue&type=template&id=45a9da0e&lang=pug&"
import script from "./Tarrifs.vue?vue&type=script&lang=js&"
export * from "./Tarrifs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports